export const TFG_BASE_KEY = 'tfg';

export const tfgApiQueryKeys = {
  settings: (tourId: string) => [TFG_BASE_KEY, 'settings', tourId] as const,
  airports: () => [TFG_BASE_KEY, 'airports'] as const,
  deklaracjaPreview: (year: number, month: number) =>
    [TFG_BASE_KEY, 'deklaracja-preview', year, month] as const,
  clientHistory: (clientId: string) =>
    [TFG_BASE_KEY, 'client-history', clientId] as const,
  participantHistory: (participantId: string) =>
    [TFG_BASE_KEY, 'participant-history', participantId] as const,
};
